<p-dialog
  [(visible)]="showPopup"
  breakpoints="{ '960px': '75vw', '640px': '100vw' }"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '470px', textAlign: 'center' }"
>
  <h3 class="mt-0 px-6">{{ 'MATCHED_POPUP.TITLE' | translate }}</h3>
  <p class="text-14">
    {{ 'MATCHED_POPUP.MESSAGE' | translate }}
  </p>
  <p-button [label]="'MATCHED_POPUP.CLOSE' | translate" styleClass="p-button-warning mt-3 text-14 w-4" (click)="closeDialog()"></p-button>
</p-dialog>
